module.exports = __webpack_public_path__ + "img/fashion.fd2ef009.png";